/** Approved category 18: existence of recorded email events, with no operand. */
export const CRM_EMAIL_EVENT_FIELDS = [
  { value: "email_opened", label: "Email opened", eventType: "opened" },
  { value: "email_clicked", label: "Email clicked", eventType: "clicked" },
  { value: "email_bounced", label: "Email bounced", eventType: "bounced" },
] as const;
export type CrmEmailEventField =
  (typeof CRM_EMAIL_EVENT_FIELDS)[number]["value"];
export type CrmEmailEventType =
  (typeof CRM_EMAIL_EVENT_FIELDS)[number]["eventType"];
export const CRM_EMAIL_EVENT_CONDITIONS = [
  "has_happened",
  "has_not_happened",
] as const;
export type CrmEmailEventCondition =
  (typeof CRM_EMAIL_EVENT_CONDITIONS)[number];

export const isCrmEmailEventField = (
  field: string,
): field is CrmEmailEventField =>
  CRM_EMAIL_EVENT_FIELDS.some((item) => item.value === field);

export const normalizeCrmEmailEventValue = (
  condition: string,
  value: unknown,
): "" | null =>
  CRM_EMAIL_EVENT_CONDITIONS.some((item) => item === condition) &&
  (value === undefined || (typeof value === "string" && value.trim() === ""))
    ? ""
    : null;
